import { toNumber } from './to-number.js';
export default function currencyToNumber(currencyString) {
    const parsed = toNumber(currencyString);
    return isNaN(parsed) ? null : parsed;
}
//# sourceMappingURL=currency-to-number.js.map